import { useState } from 'react';
import { useTranslation } from 'next-i18next';

import { useScreenSizeContext } from '@/components/ScreenSize.context';

import { useAppSelector } from '@/redux';
import { CallToActionKind } from '@/types';
import { getPushListingUrl, getPushListingWebp } from '@/utils/espotUtils';
import { NS } from '@/constants';

import Icon from '@/components/common/iconedLinks/Icon';
import CenteredModal from '@/components/layout/modals/CenteredModal';
import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';

import styles from './Push.module.scss';
import { DESIGN_SYSTEM_SIZES } from '@/constants/styles';
import { PUSH_LISTING_IMAGES_HEIGHT } from '@/constants/espot';
import { URLS } from '@/constants/urls';

export type PushProps = {
  url: string;
  img: string;
  contentTitle: string;
  desc: string;
  label?: string;
  modalTitle?: string;
  informations?: string;
  hasButton: boolean;
  hasArrowIcon: boolean;
};

export const Push = ({ url, img, contentTitle, desc, label, modalTitle, informations, hasButton, hasArrowIcon }: PushProps) => {
  const { isMobile } = useScreenSizeContext();
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isProductPage = useAppSelector(({ product }) => product.id);
  const computedHeight = isMobile ?
    PUSH_LISTING_IMAGES_HEIGHT.MOBILE : isProductPage ?
      PUSH_LISTING_IMAGES_HEIGHT.DESKTOP.PRODUCT :
      PUSH_LISTING_IMAGES_HEIGHT.DESKTOP.CATEG;

  const handleClick = () => {
    if (typeof window !== 'undefined') {
      window.location.href = url;
    }
  };
  return (
    <>
      <div style={{
        backgroundImage: `image-set(
    url(${getPushListingWebp(isMobile, img)}) type("image/webp"),
    url(${getPushListingUrl(isMobile, img)}) type("image/jpeg")
  )`
      }}>
        <div
          className={`${styles.container}${url ? ' ' + styles.hoverable : ''}`}
          style={{
            height: computedHeight,
          }}
          onClick={url && handleClick}
        >
          <div className={styles.content}>
            <div
              dangerouslySetInnerHTML={{ __html: contentTitle }}
              className={styles.title}
            />
            {desc && desc !== '' &&
              <div
                dangerouslySetInnerHTML={{ __html: desc }}
                className={styles.description}
              />
            }
            {hasButton &&
              <CallToActionContainer
                kind={CallToActionKind.REVERSE_PRIMARY}
                className={styles.button}
                buttonSize={isMobile ? DESIGN_SYSTEM_SIZES.SMALL : DESIGN_SYSTEM_SIZES.LARGE}
              >
                {label || t('btn.discover')}
              </CallToActionContainer>
            }
          </div>
          <div className={styles.icons}>
            {informations &&
              <Icon
                src={URLS.INFORMATION_SOLID_WHITE}
                alt={t('informations', { ns: NS.ALTER })}
                width={24}
                height={24}
                className={styles['information-icon']}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsModalOpen(true);
                }}
              />
            }
            {hasArrowIcon &&
              <Icon
                src={URLS.ANGLE_RIGHT_WHITE}
                alt={t('angleRightIcon', { ns: NS.ALTER })}
                width={24}
                height={24}
                className={styles['angle-icon']}
              />
            }
          </div>
        </div>
      </div>
      {informations &&
        <CenteredModal
          opened={isModalOpen}
          title={modalTitle || t('product.conditions')}
          customContent={informations}
          cancelAction={() => setIsModalOpen(false)}
        />
      }
    </>

  );
};

export default Push;
